import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { type CreateShipmentFailure } from "./return";

export enum EasyPostErrorCodes {
  AUSPOST_ADDRESS_VALIDATION_ERROR = "AUSPOST_ADDRESS_VALIDATION_ERROR",
  CARRIER_DID_NOT_RESPOND = "CARRIER_DID_NOT_RESPOND",
  CARRIER_REQUEST_TIMEOUT = "CARRIER_REQUEST_TIMEOUT",
  INVALID_FTR_EXEMPTION_OR_AES_CITATION = "INVALID_FTR_EXEMPTION_OR_AES_CITATION",
}

export enum RedoShipmentErrorCodes {
  LABEL_PRICE_TOO_HIGH = "LABEL_PRICE_TOO_HIGH",
}

export enum UnknownShipmentErrorCodes {
  UNKNOWN_EASYPOST_ERROR = "UNKNOWN_EASYPOST_ERROR",
  UNKNOWN_SHIPMENT_ERROR = "UNKNOWN_SHIPMENT_ERROR",
}

export type ShipmentErrorCodes =
  | EasyPostErrorCodes
  | RedoShipmentErrorCodes
  | UnknownShipmentErrorCodes;

export type KnownShipmentErrorCode = Exclude<
  ShipmentErrorCodes,
  UnknownShipmentErrorCodes
>;

export type KnownShipmentFailure = CreateShipmentFailure & {
  errorCode: KnownShipmentErrorCode;
};

export const RedoShipmentErrorMessages: Record<RedoShipmentErrorCodes, string> =
  {
    [RedoShipmentErrorCodes.LABEL_PRICE_TOO_HIGH]: "Label price too high",
  } as const;

export const EasyPostErrorMessages: Record<EasyPostErrorCodes, string> = {
  [EasyPostErrorCodes.AUSPOST_ADDRESS_VALIDATION_ERROR]:
    "Your combination of suburb, state & postcode doesn't match",
  [EasyPostErrorCodes.CARRIER_DID_NOT_RESPOND]:
    "carrier is not responding to our request",
  [EasyPostErrorCodes.CARRIER_REQUEST_TIMEOUT]:
    "carrier timed out responding to our request",
  [EasyPostErrorCodes.INVALID_FTR_EXEMPTION_OR_AES_CITATION]:
    "The FTR Exemption or AES Citation you provided is not valid for EEI",
} as const;

export const ShipmentErrorCodeValues = [
  ...Object.values(EasyPostErrorCodes),
  ...Object.values(RedoShipmentErrorCodes),
  ...Object.values(UnknownShipmentErrorCodes),
];

export const EasyPostErrorCodesZodSchema = createEnum(EasyPostErrorCodes, {
  enumName: "EasyPostErrorCodes",
});

export const RedoShipmentErrorCodesZodSchema = createEnum(
  RedoShipmentErrorCodes,
  { enumName: "RedoShipmentErrorCodes" },
);

export const UnknownShipmentErrorCodesZodSchema = createEnum(
  UnknownShipmentErrorCodes,
  { enumName: "UnknownShipmentErrorCodes" },
);

export const ReturnShipmentErrorCodesZodSchema = z.union([
  EasyPostErrorCodesZodSchema,
  RedoShipmentErrorCodesZodSchema,
  UnknownShipmentErrorCodesZodSchema,
]);
